const PATH_SEPARATOR = ' › ';

export const pulseTopicOptionLabel = (id: string): string =>
  id.split('|').filter(Boolean).map(titleCaseSegment).join(PATH_SEPARATOR);

const titleCaseSegment = (segment: string): string =>
  segment
    .replace(/-+/g, ' ')
    .toLowerCase()
    .replace(/(^|[^a-z])[a-z]/g, (match: string) => match.toUpperCase());
